import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFocusExposure: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconFocusExposure"><Path d="M3.75 8V6.75C3.75 5.09315 5.09315 3.75 6.75 3.75H8M3.75 16V17.25C3.75 18.9069 5.09315 20.25 6.75 20.25H8M16 3.75H17.25C18.9069 3.75 20.25 5.09315 20.25 6.75V8M20.25 16V17.25C20.25 18.9069 18.9069 20.25 17.25 20.25H16M15.25 12C15.25 13.7949 13.7949 15.25 12 15.25C10.2051 15.25 8.75 13.7949 8.75 12C8.75 10.2051 10.2051 8.75 12 8.75C13.7949 8.75 15.25 10.2051 15.25 12Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconFocusExposure;
